export default {
  namespaced: true,
  state: {
    userInfo: {
      name: 'store',
      id: 1,
      activeTabName: 'second'
    },
    commonParams: {
      customer_id: localStorage.getItem('customerId'),
      udid: localStorage.getItem('udid'),
      app_version: localStorage.getItem('appVersion'),
      appMarket_channel: localStorage.getItem('appMarketChannel'),
      os: localStorage.getItem('os'),
      package_name: localStorage.getItem('packageName')
    },
    isLogin: false
  },
  mutations: {
    tabClick(state, payload) {
      state.activeTabName = payload.name
    }
  },
  actions: {
    tabClick(context, payload) {
      context.commit('tabClick', payload)
    }
  }
}
